const DisplayGroupEndpoints = {
  GET_DISPLAY_GROUPS: "/display-groups/",
  GET_DISPLAY_GROUPS_BY_WORKSPACE: (workspaceId: string) => `/display-groups/?workspace_id=${workspaceId}`,
  CREATE_DISPLAY_GROUP: "/display-groups/",
  UPDATE_DISPLAY_GROUP: (id: string) => `/display-groups/${id}/`,
  DELETE_DISPLAY_GROUP: (id: string) => `/display-groups/${id}/`,
};

export default DisplayGroupEndpoints;
